import React from 'react';
import { useTranslation } from 'react-i18next';

export const AgentToast = ({ message, undoAction, onDismiss }) => {
    const { t } = useTranslation();

    const handleUndo = () => {
        if (undoAction) undoAction();
        onDismiss();
    };

    return (
        <div className="agent-toast">
            <span className="agent-toast__message">{message}</span>
            {undoAction && (
                <button className="agent-toast__undo" onClick={handleUndo}>
                    {t('agent_chat.undo')}
                </button>
            )}
            <button className="agent-toast__close" onClick={onDismiss}>
                <i className="fas fa-times"></i>
            </button>
        </div>
    );
};
